import React from 'react'
import Dialog from 'material-ui/Dialog'
import { useEffect, useState } from 'react'
import * as SettingMenuPremiumAction from '../../../actions/SettingMenuPremium'
import { Alert ,Snackbar } from '@mui/material'
export const ModalSettingMenuPremiumDelete = (props) => {
    const [isShow, setShow] = useState(false)
    const [messageServerError, setMessageServerError] = useState('')
    const [openSnackbar, setOpenSnackbar] = useState(false)
    useEffect(() => {
        setShow(props.isShow)
    }, [props.isShow])

    const closeDialog = () => setShow(true)

    const onCancel = () => {
        closeDialog()
        props.resetToggle()
    }
    const titleStyle = {
        margin: '0 69px 25px 70px',	
        fontFamily: 'HiraKakuPro-W6',
        fontSize: '18px',
        fontWeight: '700',
        fontStyle: 'normal',
        lineHeight: 1.17,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#eb3d3d',
      };
    const pStyle = {
        margin: '25px 0',	
        fontFamily: 'HiraKakuPro-W3',
        fontSize: '14px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: '#212121',
    }
    const textStyle = {
        color: '#ec407a',
    }

    const handleCloseSnackbar = () =>{
        setOpenSnackbar(false)
    }

    const handleDelete = async (event) => {
        event.preventDefault();
        const dispatch = props.dispatch;
        try {
            const response = await  dispatch(SettingMenuPremiumAction.deleteMenuPremium(props.id))
            console.log(response)
            if (response.code === 0) {
                await dispatch(SettingMenuPremiumAction.getAllMenuPremium())
                props.resetToggle()
            } else {
                setOpenSnackbar(true);
                setMessageServerError(response.message)
            }
            } catch (error) {
                setOpenSnackbar(true)
            }	
    }

    return (
        
        <div>
            <Dialog
                modal={false}
                open={isShow}
                bodyClassName="modal-missing__profile setting-popup-overflow"
                contentClassName="modal-menu-premium-paper setting-popup-template"

            >
                <div className="modal-missing__profile-content" id="content-appeal__message">
                    <h3 style={titleStyle} >メニュー削除</h3>
                    <p style={pStyle}>以下のプレミアムメニューを削除します。本当によろしいですか？<br></br></p>
                    <p style={pStyle}> メニュー名<br></br>
                        <span style={{fontWeight: '700'}}>{props.nameDelete}</span></p>
                </div>
                <div className="modal-appeal__message-btn" style={{ justifyContent:'space-evenly' }}>
                    <input
                        type="button"
                        value="キャンセル"
                        className="modal-btn-menupremium"
                        style={{border:'none'}}
                        onClick={onCancel}
                    />
                    <input
                        type="button"
                        value="削除する"
                        onClick={handleDelete}
                        className="modal-btn-menupremium"
                        style={{color:'#ffffff', background:'#ec407a', border:'none'}}
                    />
                </div>
                  <Snackbar
                    open={openSnackbar}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={handleCloseSnackbar} severity="error">
                        {messageServerError}
                    </Alert>
                </Snackbar>
            </Dialog>
        </div>
    )
}
